/* eslint-disable no-underscore-dangle */
import { Switch } from "antd";
import React from "react";
import DeleteIcon from "../../../icons/js/DeleteIcon";
import { EditPencilIcon } from "../../../icons/js/PencilIcon";

export const emailData = [
  {
    id: 1,
    to: "Jessica Lee",
    email: "jessicalee@example.com",
    subject: "Re: Checking In: Let's Continue Chatting",
    message:
      "Hello Ethan, Thank you for your interest in our services. If you'd like, I can arrange a demo to walk you throu...",
    timeStamp: "2024-02-05T09:20:00",
  },
  {
    id: 2,
    to: "Sarah Johnson",
    email: "sarahjohnson@example.com",
    subject: "Checking In: Let's Continue Chatting",
    message:
      "Hello Ethan, Thank you for your interest in our services. If you'd like, I can arrange a demo to walk you throu...",
    timeStamp: "2024-01-02T11:00:00",
  },
  {
    id: 3,
    to: "Michael Smith",
    email: "michaelsmith@example.com",
    subject: "Fwd: Checking In: Let's Continue Chatting",
    message:
      "Hello Ethan, Thank you for your interest in our services. If you'd like, I can arrange a demo to walk you throu...",
    timeStamp: "2024-01-18T15:30:00",
  },
  {
    id: 4,
    to: "David Brown",
    email: "davidbrown@example.com",
    subject: "Checking In: Let's Continue Chatting",
    message:
      "Hello Ethan, Thank you for your interest in our services. If you'd like, I can arrange a demo to walk you throu...",
    timeStamp: "2024-03-15T17:45:00",
  },
  {
    id: 5,
    to: "Emily Davis",
    email: "emilydavis@example.com",
    subject: "Checking In: Let's Continue Chatting",
    message:
      "Hello Ethan, Thank you for your interest in our services. If you'd like, I can arrange a demo to walk you throu...",
    timeStamp: "2024-04-29T16:45:00",
  },
  {
    id: 6,
    to: "Chris Taylor",
    email: "christaylor@example.com",
    subject: "Checking In: Let's Continue Chatting",
    message:
      "Hello Ethan, Thank you for your interest in our services. If you'd like, I can arrange a demo to walk you throu...",
    timeStamp: "2024-05-30T09:00:00",
  },
];

export const emailTemplates = [
  {
    templateTitle: "Share Helpful Resource",
    owner: "Tom Cooper",
    sharedWith: "Company",
    isActive: true,
  },
  {
    templateTitle: "The Follow-Up Email that Follows Through",
    owner: "Tom Cooper",
    sharedWith: "Company",
    isActive: true,
  },
  {
    templateTitle: "Follow-up on trade completed",
    owner: "Tom Cooper",
    sharedWith: "Company",
    isActive: false,
  },
  {
    templateTitle: "Price discussion follow-up",
    owner: "FunnelAI Admin",
    sharedWith: "Company",
    isActive: false,
  },
  {
    templateTitle: "Thanks you email",
    owner: "FunnelAI Admin",
    sharedWith: "Location : Default",
    isActive: false,
  },
];

/**
 * @typedef {{id:number, mediaType:string,mediaUrl:string,size:string}} MMSObject
 */

/**
 * @typedef {Object} EmailsData
 * @property {string | number} id
 * @property {string} bodyHtml
 * @property {string} subject
 * @property {string} from_
 * @property {string} to
 * @property {string} createTs
 * @property {string} latestActivityTs
 * @property {string} sesMessageId
 * @property {{id:string, fullName:string}} lead
 * @property {{id:string,
 *user:{id:string, fullName:string},
 *direction:"TO_LEAD" | "TO_USER" | "FROM_LEAD" | "FROM_USER" | "FROM_OTTO" | "FROM_SALE_PERSON",
 *mmsObjects:MMSObject[]}} message
 */

/**
 *
 * @param {EmailsData} selectedEmail
 */
export const setForwardMessage = selectedEmail => {
  // Format the date from createTs
  const emailDate = new Date(selectedEmail.createTs).toLocaleString();
  // Create the forward header
  const forwardHeader = `
    <div style="padding: 20px 0; border-bottom: 1px solid #ddd;">
      <div><strong>From:</strong> ${selectedEmail.from_}</div>
      <div><strong>To:</strong> ${selectedEmail.to}</div>
      <div><strong>Sent:</strong> ${emailDate}</div>
      <div><strong>Subject:</strong> ${selectedEmail.subject}</div>
    </div>
  `;

  // Combine the header with the original message body.
  // The wrapping <p> carries id="reply-info" so the AI-generation flow in
  // EmailTextBox.jsx can locate the start of the quoted block and insert
  // generated content above it — same marker convention as setReplyMessage.
  const forwardedBody = `
    <div style="font-family: Arial, sans-serif;">
      <p id="reply-info">---------- Forwarded message ----------</p>
      ${forwardHeader}
      <div style="padding-top: 20px;">
        ${selectedEmail.bodyHtml}
      </div>
    </div>
  `;

  return forwardedBody;
};

/**
 *
 * @param {EmailsData} selectedEmail
 */
export const setReplyMessage = selectedEmail => {
  // Format the date from createTs
  const emailDate = new Date(selectedEmail.createTs).toLocaleString();

  // Create the reply quote header
  const replyHeader = `
   <br/><div id="reply-info" style="padding: 10px 0; color: #666;">
      <div>On ${emailDate}, ${selectedEmail.from_} wrote:</div>
    </div>
  `;

  // Wrap the original content in blockquote
  const quotedContent = `
    <blockquote style="
      margin: 0 0 0 0.8ex;
      border-left: 1px solid #ccc;
      padding-left: 1ex;
      color: #666;
    ">
      ${selectedEmail.bodyHtml}
    </blockquote>
  `;

  // Combine everything with a space for the reply
  const replyBody = `
    <div style="font-family: Arial, sans-serif;">
      <div style="margin-bottom: 10px;">
      </div>
      ${replyHeader}
      ${quotedContent}
    </div>
  `;

  return replyBody;
};
